import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router";
import testBackground from "../assets/stacked-waves-haikei.svg";

const Instructions = () => {
  const navigate = useNavigate();
  return (
    <div
      style={{
        minHeight: "100vh",
        marginTop: "0",
        backgroundImage: `url(${testBackground})`,
        backgroundSize: "cover",
        backgroundRepeat: "repeat",
        marginBottom: "0.3%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          // marginTop: "15vh",
          // marginBottom: "5vh",
          marginLeft: "3%",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "200%",
            flexBasis: "100%",
            flexShrink: 2,
            textAlign: "left",
            fontWeight: "bold",
          }}
        >
          Homework Portal Instructions
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
          marginLeft: "2.5%",
          marginBottom: "3vh",
        }}
      >
        {/* <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => {
            navigate("/dashboard");
          }}
        >
          Back
        </Button> */}
        <IconButton
          sx={{
            borderRadius: "50%",
            // height: "3vh",
            "&.MuiIconButton-root": {
              backgroundColor: "primary.main",
              color: "white !important",
            },
          }}
          onClick={() => {
            navigate("/dashboard");
          }}
          size="small"
        >
          <ArrowBackIcon />
        </IconButton>
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          marginBottom: "0%",
        }}
      >
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionDetails>
            <Typography variant="h3">
              Welcome to the CriCo English Homework Portal/App!
            </Typography>
            <Typography>
              We understand that homework can sometimes be challenging, so we've
              created this portal/app to make it easier and more fun for you to
              complete your assignments. Here, you'll find step-by-step
              instructions on how to use the Homework Portal/App effectively.
              Let's get started!
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Login or Create Your Account</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>To begin, open the Homework Portal/App on your device.</li>
                <li>
                  If you already have an account, simply enter your username and
                  password to log in.
                </li>
                <li>
                  If you're new, click on "Create Account" and follow the
                  prompts to set up your profile
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Dashboard Overview</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingBottom: "0" }}>
            <Typography>
              Once you're logged in, you'll land on your dashboard. Here's what
              you can expect:
              <ul>
                <li>
                  Profile: Student name, Batch, Level all these information can
                  be found
                </li>
                <li>
                  Lessons: This section displays all your pending and upcoming
                  lessons. Click on a lesson to see the details.
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Lessons</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>
                  Click on the “Homework” Icon to view your homework tasks. Each
                  lesson will have a title, description, and due date.
                </li>
                <li>To start working on a lesson, click the "Lesson" icon</li>
                <li>
                  You can view category wise tabs for each lesson.For instance
                  for lesson 1 will have phonics,blends,HFW,Dictionary and Read
                  & comprehend
                </li>
                <li>
                  Once you've completed the lesson, click "Submit" to turn it
                  in. Make sure you've done your best work!
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Messages</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>
                  If you have questions about a lesson or need help, You can
                  make a note of it and ask your course instructor in the
                  upcoming class.
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Profile</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>
                  Review and update your profile information as needed. Make
                  sure to contact your course instructor for help in editing
                  this info
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Tips for Success</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>
                  Set aside a dedicated homework time each day to stay on top of
                  your lessons
                </li>
                <li>
                  Don't hesitate to ask for help if you're stuck on a problem.
                  Your teachers and classmates are here to support you
                </li>
                <li>
                  Take breaks during your study sessions to stay refreshed and
                  focused.
                </li>
                <li>
                  Always submit your lessons on time. Late submissions may
                  result in lower grades in your assessments
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Troubleshooting</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ paddingBottom: "0" }}>
            <Typography>
              If you encounter any issues while using the Homework Portal/App,
              such as login problems or technical glitches, don't worry! Here's
              what you can do:
              <ul>
                <li>Check your internet connection.</li>
                <li>Logout and log back in</li>
                <li>Clear your browser/app cache.</li>
                <li>
                  Contact course instructors for assistance through the provided
                  contact information
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ height: "10vh" }}
          >
            <Typography variant="h4">Stay Safe Online</Typography>
          </AccordionSummary>
          <AccordionDetails sx={{ padding: "0" }}>
            <Typography>
              <ul>
                <li>
                  Be cautious when sharing personal information online. Only
                  communicate with people you trust.
                </li>
                <li>
                  If you ever feel uncomfortable or encounter any inappropriate
                  content, report it to a trusted adult or the platform's
                  support team immediately
                </li>
              </ul>
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion
          style={{
            width: "95%",
            boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
          }}
        >
          <AccordionDetails>
            <Typography>
              Remember, the Homework Portal/App is here to make your homework
              experience more enjoyable and efficient. With these instructions
              in mind, you're well on your way to becoming a homework superstar!
              Good luck, and happy learning
            </Typography>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};
export default Instructions;
